import { DatasetRule, MetricTypes, UpdateMetricResponse } from './generated/models'
import { REQUEST_OPTIONS } from './_configs'
import { CreateTableColumnRequest, DatasetTablesColumnsControllerApi, UpdateTableColumnRequest } from './generated'

const columnsApiClient = new DatasetTablesColumnsControllerApi()

export type CreateDatasetColumnsParams = {
  name: string
  description: string
  type: MetricTypes
  synonyms?: Array<string>
  rules: DatasetRule[]
  isActive: boolean
}

export const createTableColumn = async (datasetId: string, tableId: string, params: CreateDatasetColumnsParams) => {
  const body: CreateTableColumnRequest = {
    datasetId,
    tableId,
    createColumnRequest: {
      columnName: params.name,
      columnDescription: params.description,
      columnType: params.type,
      rules: params.rules,
      columnSynonyms: params.synonyms,
      isActive: params.isActive ?? true,
    },
  }
  return columnsApiClient.createTableColumn(body, REQUEST_OPTIONS)
}

export type UpdateDatasetColumnsParams = {
  version: number
  name?: string
  description?: string
  rules?: DatasetRule[]
  formula?: string
  synonyms?: Array<string>
  type?: MetricTypes
  isActive?: boolean
}

export const updateTableColumn = async (
  columnId: string,
  datasetId: string,
  tableId: string,
  force: boolean,
  params: UpdateDatasetColumnsParams,
): Promise<UpdateMetricResponse> => {
  const body: UpdateTableColumnRequest = {
    columnId,
    datasetId,
    tableId,
    force,
    updateColumnRequest: {
      columnVersion: params.version,
      columnName: params.name,
      columnDescription: params.description,
      columnSynonyms: params.synonyms,
      rules: params.rules,
      columnType: params.type,
      isActive: params.isActive,
    },
  }

  return columnsApiClient.updateTableColumn(body, REQUEST_OPTIONS)
}

type DeleteTableColumnParams = {
  datasetId: string
  tableId: string
  columnId: string
  force: boolean
}
export const deleteTableColumn = async (params: DeleteTableColumnParams) => {
  return columnsApiClient.deleteTableColumn(params, REQUEST_OPTIONS)
}
